var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('object',{ref:"object",staticClass:"preview",attrs:{"type":"application/pdf","data":""}},[_c('embed',{ref:"embed",staticClass:"preview",attrs:{"type":"application/pdf","src":"","frameborder":"0"}}),_c('embed')])])}
var staticRenderFns = []

export { render, staticRenderFns }